import axiosInstance from "@/services/axiosInstance";
import type { AxiosPromise } from "axios";
import type {
    MasqueradeTokenResponse,
    MasqueradeableUser,
} from "@/types/api/data-contracts";

class MasqueradeService {
    // eslint-disable-next-line no-use-before-define
    private static instance: MasqueradeService;

    public static getInstance(): MasqueradeService {
        if (!MasqueradeService.instance) {
            MasqueradeService.instance = new MasqueradeService();
        }
        return MasqueradeService.instance;
    }

    /**
     * Get temporary token for MoR masquerade mode.
     * This token should be exchanged using the admin get_token endpoint.
     */
    getTemporaryToken(userUuid: string): AxiosPromise<MasqueradeTokenResponse> {
        return axiosInstance.post(
            "/companies/merchant-of-record/masquerade/get-temporary-token/",
            {
                user_uuid: userUuid,
            }
        );
    }

    /**
     * Get list of users for a company managed by the MoR.
     */
    getCompanyUsers(companyUuid: string): AxiosPromise<MasqueradeableUser[]> {
        return axiosInstance.get(
            `/companies/merchant-of-record/masquerade/companies/${companyUuid}/users/`
        );
    }
}

export default MasqueradeService;
